<template lang="html">
  <div id="text-page">
    <section class="header-banners-section-s2">
    </section>

    <section class="container main-section" data-aos="fade-in" data-aos-duration="1000">
      <!-- Header -->
      <div class="text-center mb-5">
        <div class="d-inline-flex align-items-center justify-content-center rounded-circle mb-4 aviso-icon-wrap">
          <i class="fa-solid fa-shield-halved fa-2x text-danger"></i>
        </div>
        <h1 class="mb-2 text-center page-title">Aviso de Privacidad</h1>
        <p class="text-muted mb-0 txt-cprimary">
          Última actualización: Enero 2025
        </p>
      </div>

      <!-- Content -->
      <div class="aviso-content">
        <section class="mb-5">
          <h2 class="h5 font-weight-bold mb-3 d-flex align-items-center">
            <i class="fa-solid fa-file-lines fa-lg text-danger mr-2"></i>
            Identidad y Domicilio del Responsable
          </h2>
          <p>
            <strong>EcoMéxico S.A. de C.V.</strong> (en adelante "ECO México"), con domicilio en Ciudad de México, México,
            es responsable del tratamiento de sus datos personales conforme a la Ley Federal de Protección de Datos Personales
            en Posesión de los Particulares.
          </p>
        </section>

        <section class="mb-5">
          <h2 class="h5 font-weight-bold mb-3">Datos Personales que Recabamos</h2>
          <p>
            Para las finalidades señaladas en el presente aviso de privacidad, podemos recabar sus datos personales
            de distintas formas cuando usted:
          </p>
          <ul class="mb-4">
            <li>Visita nuestro sitio web</li>
            <li>Solicita información sobre nuestros productos o servicios</li>
            <li>Realiza una compra en línea</li>
            <li>Se registra como distribuidor</li>
            <li>Solicita soporte técnico</li>
            <li>Crea una cuenta de usuario</li>
          </ul>
          <p>
            Los datos personales que podemos recabar incluyen:
          </p>
          <ul>
            <li>Nombre completo</li>
            <li>Correo electrónico</li>
            <li>Número telefónico</li>
            <li>Dirección de envío y facturación</li>
            <li>RFC y constancia de situación fiscal</li>
            <li>Información de pago (procesada a través de pasarelas seguras)</li>
            <li>Empresa u organización</li>
            <li>Puesto o cargo</li>
          </ul>
        </section>

        <section class="mb-5">
          <h2 class="h5 font-weight-bold mb-3">Finalidades del Tratamiento</h2>
          <p>
            Los datos personales que recabamos serán utilizados para las siguientes finalidades:
          </p>

          <h3 class="h6 font-weight-bold mt-4 mb-2">Finalidades Primarias (Necesarias):</h3>
          <ul class="mb-4">
            <li>Procesar y gestionar sus pedidos y compras</li>
            <li>Proveer los productos y servicios solicitados</li>
            <li>Emitir facturas y comprobantes fiscales</li>
            <li>Gestionar garantías y soporte técnico</li>
            <li>Verificar su identidad y prevenir fraudes</li>
            <li>Cumplir con obligaciones legales y regulatorias</li>
            <li>Gestionar solicitudes de distribución</li>
          </ul>

          <h3 class="h6 font-weight-bold mt-4 mb-2">Finalidades Secundarias (Opcionales):</h3>
          <ul>
            <li>Enviar comunicaciones promocionales y newsletters</li>
            <li>Realizar estudios de mercado y análisis estadísticos</li>
            <li>Informar sobre nuevos productos, servicios y eventos</li>
            <li>Mejorar nuestros productos, servicios y sitio web</li>
          </ul>
          <p class="mt-4 p-3 bg-light rounded">
            <strong>Nota:</strong> Usted puede oponerse al tratamiento de sus datos personales para las finalidades
            secundarias en cualquier momento, sin que ello afecte el servicio que le brindamos.
          </p>
        </section>

        <section class="mb-5">
          <h2 class="h5 font-weight-bold mb-3">Transferencia de Datos</h2>
          <p>
            Sus datos personales pueden ser transferidos y tratados dentro y fuera del país por las siguientes entidades:
          </p>
          <ul>
            <li>Proveedores de servicios de pago y facturación electrónica</li>
            <li>Empresas de mensajería y logística para entrega de productos</li>
            <li>Proveedores de servicios de tecnología y almacenamiento en la nube</li>
            <li>Socios comerciales y distribuidores autorizados</li>
          </ul>
          <p class="mt-4">
            Todas las transferencias se realizan cumpliendo con las medidas de seguridad y confidencialidad establecidas
            por la ley, y requieren que los terceros mantengan la confidencialidad de sus datos personales.
          </p>
        </section>

        <section class="mb-5">
          <h2 class="h5 font-weight-bold mb-3">Derechos ARCO</h2>
          <p>
            Usted tiene derecho a conocer qué datos personales tenemos de usted, para qué los utilizamos y las condiciones
            del uso que les damos (Acceso). Asimismo, es su derecho solicitar la corrección de su información personal en
            caso de que esté desactualizada, sea inexacta o incompleta (Rectificación); que la eliminemos de nuestros registros
            o bases de datos cuando considere que la misma no está siendo utilizada conforme a los principios, deberes y
            obligaciones previstas en la normativa (Cancelación); así como oponerse al uso de sus datos personales para
            fines específicos (Oposición).
          </p>
          <p>
            Estos derechos se conocen como derechos ARCO. Para ejercer cualquiera de estos derechos, puede contactarnos a
            través de los medios indicados al final de este documento.
          </p>
        </section>

        <section class="mb-5">
          <h2 class="h5 font-weight-bold mb-3">Revocación del Consentimiento</h2>
          <p>
            Usted puede revocar el consentimiento que, en su caso, nos haya otorgado para el tratamiento de sus datos
            personales. Sin embargo, es importante que tenga en cuenta que no en todos los casos podremos atender su
            solicitud o concluir el uso de forma inmediata, ya que es posible que por alguna obligación legal requiramos
            seguir tratando sus datos personales.
          </p>
        </section>

        <section class="mb-5">
          <h2 class="h5 font-weight-bold mb-3">Uso de Cookies y Tecnologías de Rastreo</h2>
          <p>
            Nuestro sitio web utiliza cookies y otras tecnologías de rastreo para mejorar su experiencia de navegación,
            analizar el uso del sitio y personalizar contenidos. Estas tecnologías nos permiten:
          </p>
          <ul>
            <li>Recordar sus preferencias y configuraciones</li>
            <li>Analizar el tráfico y uso del sitio web</li>
            <li>Personalizar contenido y publicidad</li>
            <li>Mejorar la seguridad del sitio</li>
          </ul>
          <p class="mt-4">
            Usted puede configurar su navegador para rechazar cookies o recibir una notificación cuando se envíen cookies.
          </p>
        </section>

        <section class="mb-5">
          <h2 class="h5 font-weight-bold mb-3">Medidas de Seguridad</h2>
          <p>
            ECO México ha implementado medidas de seguridad administrativas, técnicas y físicas para proteger sus datos
            personales contra daño, pérdida, alteración, destrucción o uso, acceso o tratamiento no autorizados. Solo el
            personal autorizado tiene acceso a sus datos personales y está sujeto a obligaciones de confidencialidad.
          </p>
        </section>

        <section class="mb-5">
          <h2 class="h5 font-weight-bold mb-3">Cambios al Aviso de Privacidad</h2>
          <p>
            El presente aviso de privacidad puede sufrir modificaciones, cambios o actualizaciones derivadas de nuevos
            requerimientos legales, de nuestras propias necesidades por los productos o servicios que ofrecemos, de
            nuestras prácticas de privacidad o por otras causas. Nos comprometemos a mantenerlo informado sobre los
            cambios que pueda sufrir el presente aviso de privacidad, a través de nuestro sitio web.
          </p>
        </section>
      </div>

      <!-- Contact Section -->
      <div class="mt-5 mb-4 p-4 p-md-5 bg-light rounded aviso-contact">
        <h2 class="h4 font-weight-bold mb-4">Contacto para Asuntos de Privacidad</h2>
        <p class="mb-4">
          Para cualquier duda, aclaración o ejercicio de sus derechos ARCO, puede contactarnos a través de:
        </p>
        <div class="row">
          <div class="col-md-6 mb-3 mb-md-0">
            <div class="d-flex align-items-start">
              <div class="aviso-contact-icon flex-shrink-0 mr-3">
                <i class="fa-solid fa-envelope fa-lg text-danger"></i>
              </div>
              <div>
                <p class="font-weight-bold mb-1">Correo Electrónico</p>
                <p class="text-muted mb-0">privacidad@ecomexico.com</p>
              </div>
            </div>
          </div>
          <div class="col-md-6 mb-3 mb-md-0">
            <div class="d-flex align-items-start">
              <div class="aviso-contact-icon flex-shrink-0 mr-3">
                <i class="fa-solid fa-phone fa-lg text-danger"></i>
              </div>
              <div>
                <p class="font-weight-bold mb-1">Teléfono</p>
                <p class="text-muted mb-0">+52 55 1234 5678</p>
              </div>
            </div>
          </div>
          <div class="col-12 mt-3">
            <div class="d-flex align-items-start">
              <div class="aviso-contact-icon flex-shrink-0 mr-3">
                <i class="fa-solid fa-location-dot fa-lg text-danger"></i>
              </div>
              <div>
                <p class="font-weight-bold mb-1">Dirección</p>
                <p class="text-muted mb-0">
                  Oficina de Protección de Datos Personales<br />
                  Ciudad de México, México
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'AvisoPrivacidadPage',
};
</script>